// @flow
import type { BookingId } from "mmb/types/primitiveTypes"

const chatConfig = {
  // Web chat application URL
  webchatAppUrl: "https://apps.mypurecloud.ie/webchat",

  // Web chat service URL
  webchatServiceUrl: "https://realtime.mypurecloud.ie:443",

  // Numeric organization ID
  orgId: 8836,

  // Organization name
  orgName: "kiwicom",

  // Requested agent language skill (Agent must have this language skill to receive chat)
  // "language": "",

  // Priority
  priority: 3,

  // Queue Name
  queueName: "Chat_EN",

  // Queue ID
  // queueId: "6f6e6080-9c43-400c-a7fa-9da7040da3c0",

  // Log level
  logLevel: "DEBUG",

  // Locale code
  locale: "en",

  skills: [],
  // Data that will be included with interaction

  // Logo used at the top of the chat window
  companyLogo: {
    width: 600,
    height: 149,
    url: "https://www.kiwi.com/images/logos/kiwicom/navbar.png?v=1",
  },

  // Logo used within the chat window
  companyLogoSmall: {
    width: 149,
    height: 149,
    url: "https://www.kiwi.com/images/logos/kiwicom/navbar-mobile.png?v=1",
  },

  // Image used for agent
  agentAvatar: {
    width: 149,
    height: 149,
    url: "https://www.kiwi.com/images/logos/kiwicom/navbar-mobile.png?v=1",
  },

  // Text displayed with chat window is displayed
  welcomeMessage: [
    "Thank you for contacting Kiwi.com. You’ll be joined shortly by one of our Travel Consultants. In the meantime, you may be able to find the answer on our Help Centre.",
  ],
}

const injectScript = (guid: string, deploymentKey: string): Promise<boolean> => {
  const body = document && document.body

  if (!body) {
    return Promise.reject(new Error("No DOM."))
  }

  return new Promise(resolve => {
    const script = document.createElement("script")

    script.src = "https://apps.mypurecloud.com/webchat/jsapi-v1.js"
    script.id = "purecloud-webchat-js"
    script.setAttribute("region", "eu-west-1")
    script.setAttribute("org-guid", guid)
    script.setAttribute("deployment-key", deploymentKey)
    script.onload = () => {
      resolve(true)
    }
    body.appendChild(script)
  })
}

type Props = {
  name: string,
  bid: BookingId,
  reason: string,
  queueName: string,
}

// this is what their external script do, no need for including it to the page
export async function openChat({ name, bid, reason, queueName }: Props) {
  // ! - browsers are blocking popups, when I call !window.open(..)
  // popup will be blocked, and window.open() return false, but !window.open() return true
  // and popup will be shown

  const chatParams = {
    locale: chatConfig.locale,
    webchatAppUrl: chatConfig.webchatAppUrl,
    webchatServiceUrl: chatConfig.webchatServiceUrl,
    logLevel: chatConfig.logLevel,
    orgId: chatConfig.orgId,
    orgName: chatConfig.orgName,
    queueName,
    priority: chatConfig.priority,
    companyLogo: chatConfig.companyLogo,
    companyLogoSmall: chatConfig.companyLogoSmall,
    agentAvatar: chatConfig.agentAvatar,
    welcomeMessage: chatConfig.welcomeMessage,
    data: {
      firstName: name,
      customField2Label: "BID",
      customField2: bid,
      customField3Label: "Reason",
      customField3: reason,
    },
  }

  const orgGuid = "ecf7d28b-2f21-49b5-a333-a06792349ae0"
  const deploymentKey = "a7c9a7f2-3d7f-4635-84c2-a52e0a094c7b"

  await injectScript(orgGuid, deploymentKey).then(async () => {
    window.webchat = await window.ININ.webchat.create(chatParams).then(webchat => {
      return webchat.renderPopup({
        width: 500,
        height: 600,
      })
    })
  })
}
